export default __webpack_public_path__ + "static/media/vers@2x.514a6098.png";